import { FC } from 'react';
import { useRouter } from 'next/router';
import { List } from 'antd';

import SpinC from 'src/components/Layout/Spin';
import { Title } from 'src/components/Layout/Typography';
import { CATEGORY } from 'src/constants/services';
import useCategories from 'src/hooks/Categories/useCategories';
import { ICategoryByGroup } from 'src/interface';
import { formatQueryParams } from 'src/utils/func';

import classes from './style.module.css';

const TabComplaints: FC = () => {
	const r = useRouter();

	const { data, isLoading } = useCategories(CATEGORY.model.obat);

	const tabQuery = r.query?.layout ? { layout: r.query.layout } : {};

	return (
		<div className={classes.result}>
			{!isLoading ? (
				<List
					grid={{ gutter: 16, xs: 2, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
					dataSource={data ?? []}
					renderItem={(item: ICategoryByGroup, i: number) => (
						<List.Item key={i}>
							<a href={`/obat/${item.slug}${formatQueryParams(tabQuery)}`}>
								<Title level={3} text={item.name} className="fs-16 fw-400" />
							</a>
						</List.Item>
					)}
				/>
			) : (
				<SpinC />
			)}
		</div>
	);
};

export default TabComplaints;
